import React, { PropTypes } from 'react';
import B from 'bem-cn';
import './index.scss';
import getStaticContent from '../../utils/getStaticContent';

const cl = B('OurStory');

const imageHeight = 75;
let floatTries = 0;
let floatMargin = 0;

export default class OurStory extends React.Component {
  static propTypes = {
    passRef: React.PropTypes.func,
    currentPageName: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.staticContent = getStaticContent('ourStory', props.currentPageName);
  }

  updateSpacer = () => {
    const spacer = this._refSpacer;
    const container = this._floatContainer;

    spacer.style.height =
      parseInt(container.clientHeight, 10) - imageHeight + floatMargin + 'px';
    setTimeout(() => {
      const diff =
        parseInt(container.clientHeight, 10) -
        parseInt(spacer.clientHeight, 10) -
        imageHeight;

      if (Math.abs(diff) > 0 && floatTries < 15) {
        floatMargin += Math.round(diff > 0 ? 1 : -1);
        floatTries++;
        this.updateSpacer();
      } else {
        floatTries = 0;
        floatMargin = 0;
      }
    });
  };

  updateSpacerTm = () => {
    clearTimeout(this.tm);
    this.tm = setTimeout(() => {
      floatTries = 0;
      floatMargin = 0;
      this.updateSpacer();
    }, 100);
  };

  componentDidMount() {
    this.updateSpacer();

    window.addEventListener('resize', this.updateSpacerTm);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSpacerTm);
  }

  render() {
    return (
      <div className={cl} id="vision" ref={this.props.passRef}>
        <div className="container">
          <div className={cl('title')}>{this.staticContent.title}</div>
          <div className={cl('content').mix('clearfix')}>
            <div
              dangerouslySetInnerHTML={{
                __html: this.staticContent.content[0]
              }}
            />
            <div
              className={cl('floatBottomContainer')}
              ref={ref => this._floatContainer = ref}
            >
              <div
                className={cl('spacer')}
                ref={ref => this._refSpacer = ref}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: this.staticContent.content[1]
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/ourStory/index.jsx